import baseURLGlobal from '../../utils/util';
const base_Url = baseURLGlobal;

// CONSTANT
export const SOURCE_HOME = 'SOURCE_HOME';
export const SOURCE_WEBVIEW = 'SOURCE_WEBVIEW';

export const GET = 'GET';
export const POST = 'POST';

export const getQuery = () => {
	let b = window.location.search
		.slice(1)
		.split('&')
		.map((qStr) => qStr.split('='))
		.reduce((acc, inc) => {
			acc[inc[0]] = inc[1];
			return acc;
		}, {});
	// alert(b);
	// alert(b['token']);
	return b;
};
 
// for token from app
const token = getQuery()['token'] || localStorage.getItem('campaignToken');
localStorage.setItem('campaignToken', token);

export const makeApiCal = (action, onSuccess = () => {}, onFailure = () => {}) => {
	// PARAMETERS - method, route, storeData, catchError, body
	switch (action.method) {
		case GET:
			return fetch(`${base_Url}/${action.route}`, {
				method: GET,
				headers: {
					'x-access-token': token,
					'Content-Type': 'application/json',
					'Connection': 'keep-alive',
				},
			})
				.then((res) => res.json())
				.then((res) => {
					res?.status === 'success'
						? action.storeData(res?.data)
						: action.catchError(res.message);
				})
				.catch((err) => {
					action.catchError(err);
				});
		case POST:
			return fetch(`${base_Url}/${action.route}`, {
				method: POST,
				headers: {
					'x-access-token': token,
					'Content-Type': 'application/json',
					'Connection': 'keep-alive',
				},
				body: JSON.stringify(action.body),
			})
				.then((res) => res.json())
				.then((res) => {
					if (res?.status === 'success') {
						action.storeData(res?.data);
						if (onSuccess) onSuccess(res.data); // Call the success callback
					} else {
						action.catchError(res.message);
						if (onFailure) onFailure(res.message); // Call the failure callback
					}
				})
				.catch((err) => action.catchError(err));
		default:
			return;
	}
};
export const directDeepLink = (url, source, showAlert) => {
	const action = {
		method: POST,
		route: 'v2/storeDeeplink',
		body: { deeplink: url },
		storeData: (e) => console.log(e),
		catchError: (e) => console.error(e),
	};
	switch (source) {
		case SOURCE_HOME:
			// alert('1 - before api url'+ url)
			makeApiCal(action);
			let stringUrl = JSON.stringify(url);
			try {
				window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
					stringUrl
				);
			} catch (e) {
				// alert('webkit handler broken '+stringUrl)
			}

			try {
				window?.mobile?.exceuteDeeplink(stringUrl);
			} catch (e) {
				// alert('execute handler broken '+stringUrl)
			}

			try {
				window?.mobile?.onDeeplinkExecutedV2(stringUrl);
			} catch (e) {
				// alert('on deep link handler broken '+stringUrl)
			}
			break;

		case SOURCE_WEBVIEW:
			makeApiCal(action);
			window?.webkit?.messageHandlers?.onDeeplinkExecuted?.postMessage(
				`${url?.screen},${url?.paramOne},${url?.paramTwo},${url?.paramThree}`
			);

			// window?.mobile?.onDeeplinkExecuted(
			//   `${url?.screen},${url?.paramOne},${url?.paramTwo},${url?.paramThree}`
			// );

			window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));

			break;
		default:
			return;
	}
};
